import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  companyTypeTitle: {
    defaultMessage: 'Company type',
    id: 'fWyFSI',
    description: 'Profile screen: tax info section: Company type',
  },
  taxProfileTitle: {
    defaultMessage: 'Tax Profile',
    id: 'tax_profile_field_title',
    description: 'Profile screen: tax info section: Tax profile',
  },
  vatRegNoTitle: {
    defaultMessage: 'VAT REG NO',
    id: 'lYsQGl',
    description: 'Profile screen: tax info section: VAT REG NO',
  },
  title: {
    defaultMessage: 'Tax profile',
    id: 'profile_tax_profile_title',
    description: 'Profile screen: subheader for self-employed tax info',
  },
  editAction: {
    defaultMessage: 'Edit',
    id: 'global_action_edit',
    description: 'Profile screen: button text',
  },
});
